<template>
    <div class="flex flex-col gap-2" v-if="reviews && pagination && tour.average_rating">
        <h2 class="text-center mb-4 body-text !font-bold">Reviews</h2>

        <div class="flex flex-col gap-2 items-center justify-center">
            <div class="font-semibold">{{ tour.name }}</div>
            <rating :rating="tour.average_rating" :number-of-reviews="pagination.total" />
        </div>

        <div class="px-3 relative">

            <ScrollSlider>
                <div v-for="review in reviews" :key="review.id"
                    class="min-w-1/2 max-w-1/2 md:min-w-1/3 md:max-w-1/3 lg:min-w-1/4 lg:max-w-1/4">
                    <review-item :review="review" />
                </div>
            </ScrollSlider>
        </div>
    </div>
    <p-dialog v-if="pagination" v-model:visible="open" modal>

        <template #header>
            <div class="grid grid-cols-12 items-center">
                <div class="col-span-2">
                    <lazy-image>
                        <template #image="{ load }">
                            <p-image image-class="object-cover h-full" class="object-cover h-full" @load="load" :src="(tour.images[tour.cover_photo] ??
                                tour.images[0]).medium" :alt="tour.name" />
                        </template>
                    </lazy-image>
                </div>
            </div>
        </template>


        <DataView :value="reviews" layout="list" :rows="pagination.perPage" :total-records="pagination.total"
            current-page-report-template="Showing {first} to {last} of {totalRecords}" data-key="id" :first="pagination.perPage * pagination.currentPage -
                (pagination.perPage + 1)
                " lazy @update:first="0">
            <template #list="{ items }">
                <div class="flex items-center justify-center">
                    <div class="flex flex-col w-full gap-2 py-10 md:w-3/4">
                        <review-item v-for="item in items" :review="item" />
                    </div>
                </div>
            </template>

            <template #footer>
                <div class="flex items-center justify-center w-full">
                    <div v-if="pagination.totalPages > pagination.currentPage"
                        class="flex flex-col items-center justify-center w-full md:w-1/2">
                        <div class="text-sm font-thin">
                            {{
                                `Showing ${pagination.count} of ${pagination.total}`
                            }}
                        </div>
                        <p-button fluid :label="`Show the next ${pagination.currentPage == pagination.totalPages - 1
                            ? pagination.total - pagination.count
                            : pagination.perPage
                            } reviews`" @click="onPage" :loading="loading" :disabled="loading" />
                    </div>
                </div>
            </template>
        </DataView>

    </p-dialog>
</template>



<script lang="ts" setup>


import { Button as PButton, Dialog as PDialog, Image as PImage, DataView } from 'primevue';
import ReviewItem from './Item.vue';
import { Pagination, Review, Tour } from '@/types';
import Rating from './Rating.vue';
import { useApiProxy } from '@/Hook/useProxy';
import { onMounted, ref } from 'vue';
import LazyImage from "@/Components/LazyImage.vue";
import ScrollSlider from '../ScrollSlider.vue';



const { tour } = defineProps<{
    tour: Tour;
}>()


const { request, error, data } = useApiProxy<{
    pagination: Pagination;
    reviews: Review[]
}>();


const open = ref(false)
const reviews = ref<Review[]>([])
const pagination = ref<Pagination>()
const loading = ref(false)


onMounted(function () {
    request(route('get.reviews', { tour_id: tour.id }))
        .then(data => {
            reviews.value = data.reviews
            pagination.value = data.pagination
        })
});


const onPage = function () {
    const page = pagination.value.currentPage + 1;
    loading.value = true;

    request(route("get.reviews", { page, tour_id: tour.id })
    ).then(function (data) {
        reviews.value = [...reviews.value, ...data.reviews];
        pagination.value = {
            ...pagination.value,
            currentPage: page,
            count: tours.value.length,
        };
        loading.value = false;
    });
};
</script>
